<template>
    <div>
        <v-card>
            <v-card-title>
                <v-text-field
                    v-model="buscarUsuariosGrupo"
                    append-icon="mdi-account-search-outline"
                    label="Buscar"
                    single-line
                    hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table
                :headers="headersUsuariosGrupo"
                :items="grupo.user"
                :search="buscarUsuariosGrupo"
            >
                <template v-slot:item.acciones="{ item }">
                <v-icon
                    class="mr-2"
                    @click="eliminarUsuario(item)"
                >
                    mdi-account-minus-outline
                </v-icon>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import axios from 'axios';
    export default {
        name: 'TablaUsuariosGrupo',
        data(){
            return {
                buscarUsuariosGrupo: '',
                headersUsuariosGrupo: [
                {
                    text: 'Nombre',
                    align: 'start',
                    filterable: true,
                    sortable: true,
                    value: 'name'
                },
                {
                    text: 'Apellidos',
                    filterable: true,
                    sortable: true,
                    value: 'apellidos',
                },
                {
                    text: 'Email',
                    filterable: true,
                    sortable: true,
                    value: 'email'
                },
                {
                    text: '',
                    filterable: false,
                    sortable: false,
                    value: 'acciones'
                }
                ]
            }
        },
        methods: {
            eliminarUsuario(usuario){
                let indiceElemento = this.grupo.user.indexOf(usuario);
                this.grupo.user.splice(indiceElemento, 1);
            }
        },
        computed: {
        ...mapState('grupos', ['grupo'])
        }
    }
</script>